export const depositApplyCells = () => {
  return [
    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      disabled: true,
      span: 12,
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      disabled: true,
      span: 12,
    },

    {
      prop: 'contractType',
      name: '合同类型',
      type: 'select',
      placeholder: '全部',
      options: [
        { value: '01', label: '租赁合同' },
        { value: '02', label: '物业合同' },
      ],
      disabled: true,
      span: 12,
    },
    {
      prop: 'customerName',
      name: '客户名称',
      type: 'input',
      disabled: true,
      span: 12,
    },
    {
      prop: 'signPartyName',
      name: '签约方',
      type: 'input',
      disabled: true,
      span: 12,
    },
    {
      prop: 'applicationType',
      name: '申请类型',
      type: 'select',
      options: [
        { value: '01', label: '退回' },
        { value: '02', label: '罚没' },
      ],
      disabled: true,
      span: 12,
    },
    {
      prop: 'applicationAmount',
      name: '申请金额',
      type: 'input',
      disabled: true,
      span: 12,
    },
    {
      prop: 'createPersonName',
      name: '申请人',
      type: 'input',
      disabled: true,
      span: 12,
    },
    {
      prop: 'gmtCreate',
      name: '申请时间',
      type: 'date',
      disabled: true,
      span: 12,
    },
  ];
};

export const depositDetailCells = () => {
  return [
    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      disabled: true,
      span: 12,
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      disabled: true,
      span: 12,
    },

    {
      prop: 'contractType',
      name: '合同类型',
      type: 'select',
      placeholder: '全部',
      options: [
        { value: '01', label: '租赁合同' },
        { value: '02', label: '物业合同' },
      ],
      disabled: true,
      span: 12,
    },
    {
      prop: 'customerName',
      name: '客户名称',
      type: 'input',
      disabled: true,
      span: 12,
    },
    {
      prop: 'signPartyName',
      name: '签约方',
      type: 'input',
      disabled: true,
      span: 12,
    },
    {
      prop: 'applicationType',
      name: '申请类型',
      type: 'select',
      options: [
        { value: '01', label: '退回' },
        { value: '02', label: '罚没' },
      ],
      disabled: true,
      span: 12,
    },
    {
      prop: 'applicationAmount',
      name: '申请金额',
      type: 'input',
      disabled: true,
      span: 12,
    },
  ];
};
